import { render, staticRenderFns } from "./Chapter.vue?vue&type=template&id=d18ceed8&scoped=true&"
import script from "./Chapter.vue?vue&type=script&lang=ts&"
export * from "./Chapter.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d18ceed8",
  null
  
)

export default component.exports